import dayjs from 'dayjs'

const dateOperations = date => {
  return dayjs(String(date).substr(0, 19))
    .locale('es')
    .format('DD [de] MMMM [de] YYYY')
}
export default dateOperations
